import { updateNotificationsRoute } from "@slfinrtl/ui-bff-routes"
import { useCallback } from "react"
import { useBffDynamic } from "src/hooks"

export const useBulkUpdateNotifications = () => {
	const updateNotificationsRequest = useBffDynamic(updateNotificationsRoute, "inline")

	return useCallback(
		(userNotificationIds: string[], status: "SEEN" | "READ"): Promise<void> =>
			updateNotificationsRequest({
				body: { ids: userNotificationIds, status },
				pathParams: {},
				queryParams: {},
			}),
		[updateNotificationsRequest],
	)
}
